export default "__VITE_ASSET__BFCD1Gzu__"